<template>
  <div class="col-md-5 col-12 mb-3" v-if="dashboardStore.filter !== 'Card'">
    <div class="card h-100">
      <div class="card-header">
        <h4>Terminal</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-xxl-5 col-lg-5 col-md-5 col-5">
            <h5>Active terminal</h5>
            <hr />
            <h3>{{ terminals.active_terminals ?? 0 }}</h3>
          </div>
          <div class="col-xxl-7 col-lg-9 col-md-9 col-9">
            <h5>Unused terminals</h5>
            <hr />
            <div class="row">
              <div class="col-4">
                <span>1 week</span>
              </div>
              <div class="col-2">
                <h3>{{ terminals.unused_terminals?.one_week }}</h3>
              </div>
              <div class="col-6">
                <p class="text-end">
                  <button class="btn btn-view" @click="applyFilter('1_week')">View terminal</button>
                </p>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-4">
                <span>2 weeks</span>
              </div>
              <div class="col-2">
                <h3>{{ terminals.unused_terminals?.two_weeks }}</h3>
              </div>
              <div class="col-6">
                <p class="text-end">
                  <button class="btn btn-view" @click="applyFilter('2_week')">View terminal</button>
                </p>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-4">
                <span>3 weeks</span>
              </div>
              <div class="col-2">
                <h3>{{ terminals.unused_terminals?.three_weeks }}</h3>
              </div>
              <div class="col-6">
                <p class="text-end">
                  <button class="btn btn-view" @click="applyFilter('3_week')">View terminal</button>
                </p>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-4">
                <span>4 weeks</span>
              </div>
              <div class="col-2">
                <h3>{{ terminals.unused_terminals?.four_weeks }}</h3>
              </div>
              <div class="col-6">
                <p class="text-end">
                  <button class="btn btn-view" @click="applyFilter('4_week')">View terminal</button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useDashboardStore } from '@/store/admin/dashboard';
import { useTerminalPerformanceStore } from '../../store/admin/terminalPerformance';
import { useRouter } from 'vue-router';

const dashboardStore = useDashboardStore();
const terminalStore = useTerminalPerformanceStore();
const router = useRouter();

const terminals = computed(() => dashboardStore.terminals);

const applyFilter = (inactivePeriod) => {
  terminalStore.setInactivePeriod(inactivePeriod);
  router.push('/admin/terminal-performance');
};
</script>

  
  <style scoped>
  .btn-view{
    color: #8476f5;
    border: white;
    background-color: white;
  }

  .btn-view:hover{
    color: #8476f5;
  }
  </style>
  